//./plugins/posthog.js
import posthog from "posthog-js";

export default {
    install(app) {
        app.config.globalProperties.$posthog = posthog.init(
            'phc_dVxm64krnSBNl7yuealFxVBBnwHKEX5U63CJGWaYgBT',
            {
                api_host: 'https://eu.i.posthog.com',
                disable_session_recording: true,
            }
        );
    },
};